// extracted by mini-css-extract-plugin
var _1 = "DepositFiatAccountStyle-module__account-number___FcJdg";
var _2 = "DepositFiatAccountStyle-module__account-number___FcJdg";
var _3 = "DepositFiatAccountStyle-module__border___djRSs";
var _4 = "DepositFiatAccountStyle-module__deposit-from-info___Z9SwP";
var _5 = "DepositFiatAccountStyle-module__deposit-from-info___Z9SwP";
var _6 = "DepositFiatAccountStyle-module__headline-account___NXaZx";
var _7 = "DepositFiatAccountStyle-module__headline-account___NXaZx";
var _8 = "DepositFiatAccountStyle-module__hr___GHRJv";
var _9 = "DepositFiatAccountStyle-module__tooltip-text___ZAWOo";
var _a = "DepositFiatAccountStyle-module__tooltip-text___ZAWOo";
export { _1 as "account-number", _2 as "accountNumber", _3 as "border", _4 as "deposit-from-info", _5 as "depositFromInfo", _6 as "headline-account", _7 as "headlineAccount", _8 as "hr", _9 as "tooltip-text", _a as "tooltipText" }
